import { ENTER_KEY } from "shared/lib/keys"
import { useEvent } from "shared/lib/useEvent"

import { InputChangeBehavior } from "../Input"

interface UseInputChangeBehaviorArgs {
  onChange: React.FormEventHandler<HTMLInputElement> | undefined
  onBlur: React.FormEventHandler<HTMLInputElement> | undefined
  onKeyDown: React.FormEventHandler<HTMLInputElement> | undefined
  changeBehavior: InputChangeBehavior
}

export function useInputChangeBehavior({
  onChange,
  onBlur,
  onKeyDown,
  changeBehavior = InputChangeBehavior.CHANGE
}: UseInputChangeBehaviorArgs) {
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = useEvent(
    ev => {
      if (changeBehavior === InputChangeBehavior.CHANGE) {
        onChange?.(ev)
      }
    }
  )

  const handleBlur: React.FocusEventHandler<HTMLInputElement> = useEvent(ev => {
    if (changeBehavior === InputChangeBehavior.BLUR) {
      // eslint-disable-next-line no-param-reassign
      ev.type = "change"
      onChange?.(ev)
    }
    // eslint-disable-next-line no-param-reassign
    ev.type = "blur"
    onBlur?.(ev)
  })

  const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = useEvent(
    ev => {
      onKeyDown?.(ev)
      if (ev.key === ENTER_KEY.key) {
        // eslint-disable-next-line no-param-reassign
        ev.type = "change"
        onChange?.(ev)
      }
    }
  )

  return {
    handleChange,
    handleBlur,
    handleKeyDown
  }
}
